import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import AppShell from "./components/AppShell";
import DashboardPage from "./pages/DashboardPage";
import TasksListPage from "./pages/TasksListPage";
import WeeklyPlannerPage from "./pages/WeeklyPlannerPage";
import CalendarPage from "./pages/CalendarPage";
import ProjectsPage from "./pages/ProjectsPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import UsersPage from "./pages/UsersPage";
import CoordinatorsPage from "./pages/CoordinatorsPage";
import AreasPage from "./pages/AreasPage";
import ReportsPage from "./pages/ReportsPage";
import NotificationsPage from "./pages/NotificationsPage";
import AuditPage from "./pages/AuditPage";
import "./App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="h-screen w-screen flex items-center justify-center">
        <div className="flex items-center gap-3 text-slate-500">
          <div className="w-6 h-6 border-2 border-crejpp border-t-transparent rounded-full animate-spin" />
          <span className="text-sm">Cargando panel…</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/" element={<Protected><AppShell /></Protected>}>
        <Route index element={<DashboardPage />} />
        <Route path="tareas" element={<TasksListPage />} />
        <Route path="planificador" element={<WeeklyPlannerPage />} />
        <Route path="calendario" element={<CalendarPage />} />
        <Route path="proyectos" element={<ProjectsPage />} />
        <Route path="proyectos/:id" element={<ProjectDetailPage />} />
        <Route path="usuarios" element={<UsersPage />} />
        <Route path="coordinadores" element={<CoordinatorsPage />} />
        <Route path="areas" element={<AreasPage />} />
        <Route path="reportes" element={<ReportsPage />} />
        <Route path="notificaciones" element={<NotificationsPage />} />
        <Route path="auditoria" element={<AuditPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <AppRoutes />
          <Toaster position="top-right" richColors closeButton duration={3500} />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}
